import { render, staticRenderFns } from "./EPRIInputFolderUploader.vue?vue&type=template&id=4e2980ca&scoped=true"
import script from "./EPRIInputFolderUploader.vue?vue&type=script&lang=js"
export * from "./EPRIInputFolderUploader.vue?vue&type=script&lang=js"
import style0 from "./EPRIInputFolderUploader.vue?vue&type=style&index=0&id=4e2980ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2980ca",
  null
  
)

export default component.exports